var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_3573_26684",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 18,
    height: 13,
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 5h18v13H3z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.533 17.153a.478.478 0 01-.338.141.458.458 0 01-.357-.141l-4.697-4.706a.456.456 0 010-.659.452.452 0 01.657 0l4.387 4.395L19.199 6.141a.466.466 0 01.668 0 .474.474 0 010 .659L9.533 17.153z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.533 17.153a.478.478 0 01-.338.141.458.458 0 01-.357-.141l-4.697-4.706a.456.456 0 010-.659.452.452 0 01.657 0l4.387 4.395L19.199 6.141a.466.466 0 01.668 0 .474.474 0 010 .659L9.533 17.153z",
    fill: "#02BD9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.533 17.153l.141.142-.14-.142zm-.695 0l.149-.134-.007-.007-.142.14zm-4.697-4.706l.142-.141-.004-.004-.138.145zm0-.659l.138.145.007-.008-.145-.137zm.657 0l-.146.137.004.005.142-.142zm4.387 4.395l-.142.142.142.142.141-.142-.141-.142zM19.199 6.141L19.057 6l.142.141zm.668 0l.142-.14L20.008 6l-.141.141zm0 .659l.141.141-.141-.141zM9.392 17.011a.278.278 0 01-.197.083v.4a.678.678 0 00.479-.2l-.282-.283zm-.197.083c-.108 0-.17-.032-.208-.075l-.298.268c.131.145.312.207.506.207v-.4zm-.215-.082l-4.698-4.706-.283.282 4.697 4.706.284-.282zm-4.701-4.71a.256.256 0 010-.369l-.276-.29a.655.655 0 000 .949l.276-.29zm.007-.377a.252.252 0 01.366 0l.291-.274a.652.652 0 00-.948 0l.291.274zm.37.005l4.387 4.395.283-.283-4.387-4.395-.283.283zm4.67 4.395L19.34 6.282 19.057 6 9.043 16.042l.283.283zM19.34 6.282c.11-.11.275-.11.386 0L20.008 6a.665.665 0 00-.95 0l.282.282zm.385 0c.1.1.1.276 0 .377l.284.282a.674.674 0 000-.94l-.284.281zm0 .377L9.392 17.012l.283.282L20.008 6.941l-.283-.282z",
    fill: "#02BD9C"
  })));
}
SvgCheckGreen.displayName = 'CheckGreen';
export default SvgCheckGreen;